module.exports = __webpack_public_path__ + "static/img/hover_btn_xcx.93df5b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaguo/hover_btn_xcx.png
// module id = Y1ES
// module chunks = 1